import * as React from 'react'

import { TabSwitcherProps } from './'

const TabSwitcher: React.SFC<TabSwitcherProps> = ({ onClick, isJSONActive }): JSX.Element => {
  const handleImageTabClick = () => {
    onClick(false)
  }
  const handleJSONTabClick = () => {
    onClick(true)
  }

  const isImageTabActive = isJSONActive ? '' : 'active'
  const isJSONTabActive = isJSONActive ? 'active': ''

  return <div className='tab-switcher'>
    <button onClick={handleImageTabClick} className={`tab-switcher-button ${isImageTabActive}`}>Image</button>
    <button onClick={handleJSONTabClick} className={`tab-switcher-button ${isJSONTabActive}`}>JSON</button>
  </div>
}

export default TabSwitcher
